import { render, staticRenderFns } from "./Wrap.vue?vue&type=template&id=fdd0500a&scoped=true&"
import script from "./Wrap.vue?vue&type=script&lang=js&"
export * from "./Wrap.vue?vue&type=script&lang=js&"
import style0 from "./Wrap.vue?vue&type=style&index=0&id=fdd0500a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fdd0500a",
  null
  
)

export default component.exports